import React from "react";
import VolumeSalesLineChart from "./VolumeSalesLineChart";
import SalesLineChart from "./SalesLineChart";
import CompanyStationFuelBalancesChart from "./CompanyStationFuelBalancesChart";
import CompanyStationSalesBarChart from "./CompanyStationSalesBarChart";
function CompanyGraphs() {
  return (
    <div className="col-lg-12 col-md-12">
      <div className="row row-sm">
        <div className="col-sm-12 col-xl-12 col-lg-12 col-md-12">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="card-option d-flex">
                <div className="card-option-title ml-auto">
                  <div className="btn-group p-0">
                    <button className="btn btn-light btn-sm" type="button">
                      Today
                    </button>
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", height: "auto" }}>
                <CompanyStationFuelBalancesChart />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-xl-12 col-lg-12 col-md-12">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="card-option d-flex">
                <div className="card-option-title ml-auto">
                  <div className="btn-group p-0">
                    <button className="btn btn-light btn-sm" type="button">
                      Today
                    </button>
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", height: "auto" }}>
                <CompanyStationSalesBarChart />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompanyGraphs;
